/**
 * Pure predicate for the coach-facing trial countdown banner.
 *
 * Centralized so the Jest regression suite can lock the rules without
 * standing up a React-testing-library harness: Private Beta Access
 * must hide the trial countdown, trial-expired banner, and "Choose a
 * plan" CTA while the grant is active, and revert cleanly once the
 * grant is revoked or expires.
 *
 * The backend (plan_status + _beta_access_active) owns the truth for
 * `plan.beta_access`: it is only `true` when both ``beta_access=true``
 * AND ``beta_access_expires_at`` is still in the future.
 */
export function shouldShowTrialBanner(plan) {
  if (!plan) return false;
  if (plan.plan !== "trial") return false;
  if (plan.beta_access) return false;
  if (plan.early_access) return false;
  return true;
}

/**
 * Coach-facing display label for the current plan.
 *
 * Beta coaches keep ``plan="trial"`` in the DB (so billing/analytics
 * stay clean), but the UI must present it as "Private Beta Access"
 * while the grant is active. When beta is revoked or has expired the
 * backend flips ``plan.beta_access`` back to false and this helper
 * returns the normal label again.
 */
export function planDisplayName(plan, planLabels) {
  if (!plan) return "";
  if (plan.beta_access) return "Private Beta Access";
  if (plan.early_access) return "Free Early Access";
  return planLabels[plan.plan] || plan.plan;
}
